import { render } from "./QuestionTwelve.vue?vue&type=template&id=9ab8e846"
import script from "./QuestionTwelve.vue?vue&type=script&lang=js"
export * from "./QuestionTwelve.vue?vue&type=script&lang=js"

import "./QuestionTwelve.vue?vue&type=style&index=0&id=9ab8e846&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__